import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AssetService } from '../../services/asset-service';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { SecurityService } from 'src/app/security/services/security-service';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { AssetShipment } from '../../models/entities/asset-shipment';
import { AssetShipmentService } from '../../services/asset-shimpnent.service';
import { AssetShipmentAsset } from '../../models/entities/asset-shipment-asset';
import { Asset } from 'src/app/assabil-kernel/models/entities/master-data/asset';
import { AssetShipmentPipe } from '../../pipes/asset-shipment-pipe';



@Component({
    selector: 'asset-shipment-widget-mobile',
    templateUrl: './asset-shipment-widget-mobile.component.html',
    styleUrls: ['./asset-shipment-widget-mobile.component.scss']
})

export class AssetShipmentWidgetMobileComponent extends BaseWidget {

  title                 : string = "Expédition Client"
  assetShipment         : AssetShipment; 
  missingBarCodes     = 123;
  barCode               : string;

  constructor(
    protected controlTablesService: ControlTablesService,
    protected assetShipmentService: AssetShipmentService,
    protected assetService        : AssetService,
    protected toastr              : ToastrService,
    protected security            : SecurityService,
    public    userService            : UserService,
    protected networkService      : LeanNetworkService,
    public    leanUtilsService    : LeanUtilsService) {
    super(toastr, leanUtilsService);
 }

  //------------------------------------------------------
  setEntity(assetShipment: AssetShipment) {
    this.assetShipment = { ...assetShipment };
  }
  getEntity(){
      return this.assetShipment;
  }
  //------------------------------------------------------

  //------------------------------------------------------
  saveRow(): Promise<BaseEntity> {
    throw new Error('Method not implemented.');
  }

  
  //------------------------------------------------------
  addAsset(){
    this.assetShipmentService.assetShipmentAssetAdd(this.assetShipment.assetShipmentCode, this.barCode).then(asset => {
      let assetShipmentAsset : AssetShipmentAsset = new AssetShipmentAsset();
      assetShipmentAsset.asset = asset;
      this.assetShipment.assetShipmentAssets.push(assetShipmentAsset);
      this.barCode = null;
      this.showSuccessFulOperation();
    });
  }


  //------------------------------------------------------
  removeAsset(assetShipmentAsset : AssetShipmentAsset){
    this.assetShipmentService.assetShipmentAssetRemove(this.assetShipment.assetShipmentCode, assetShipmentAsset.asset.barCode).then(result => {
      this.assetShipment.assetShipmentAssets.splice(this.assetShipment.assetShipmentAssets.indexOf(assetShipmentAsset), 1);
      this.showSuccessFulOperation();
    });
  }
  
  //------------------------------------------------------
  assetShipmentShip(){
    this.assetShipmentService.assetShipmentShip(this.assetShipment.assetShipmentCode).then(assetShipment => {
      this.assetShipment = assetShipment;
      this.showSuccessFulOperation();
    });
  } 
  
  //------------------------------------------------------
  assetShipmentClose(){
    this.assetShipmentService.assetShipmentClose(this.assetShipment.assetShipmentCode).then(assetShipment => {
      this.assetShipment = assetShipment;
      this.showSuccessFulOperation();
    });
  }

//---------------------------------------------------------------------------------------
assetTransferPipe  : AssetShipmentPipe = new AssetShipmentPipe();
getAssetShipmentStatus() : string{
  return this.assetTransferPipe.transform(this.assetShipment, 'progressLevel');
}
//---------------------------------------------------------------------------------------

}